export const PlaybookAndStandardMessages = {
  MAIN: {
    TITLE: 'Playbook & Standard',
    SUBTITLE:
      'Simplify compliance with step-by-step playbooks and industry-standard best practices.',
  },
  CARD: {
    TITLE: 'List Of Playbooks',
    SUBTITLE: 'Click on contracts to view the list of checks',
  },
  NO_DATA: {
    CONTENT: 'No compliance data available at the moment.',
  },
};

export const PLAYBOOK_AND_STANDARD__TABLE_COLUMNS = [
  'Service Agreement type',
  'No. of Playbooks',
  'Last Updated',
];
